import { render, staticRenderFns } from "./DeliveryFailure.vue?vue&type=template&id=3ac9175a&scoped=true&"
import script from "./DeliveryFailure.vue?vue&type=script&lang=js&"
export * from "./DeliveryFailure.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFailure.vue?vue&type=style&index=0&id=3ac9175a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9175a",
  null
  
)

export default component.exports